import { motion } from "framer-motion";
import {
  FaReact,
  FaNodeJs,
  FaJs,
  FaHtml5,
  FaCss3Alt,
  FaGitAlt,
} from "react-icons/fa";
import { SiMongodb, SiExpress, SiTailwindcss } from "react-icons/si";

const skills = [
  { name: "React", icon: <FaReact />, color: "text-cyan-400" },
  { name: "Node.js", icon: <FaNodeJs />, color: "text-green-500" },
  { name: "MongoDB", icon: <SiMongodb />, color: "text-emerald-500" },
  { name: "Express", icon: <SiExpress />, color: "text-gray-300" },
  { name: "JavaScript", icon: <FaJs />, color: "text-yellow-400" },
  { name: "Tailwind", icon: <SiTailwindcss />, color: "text-sky-400" },
  { name: "HTML5", icon: <FaHtml5 />, color: "text-orange-500" },
  { name: "CSS3", icon: <FaCss3Alt />, color: "text-blue-500" },
  { name: "Git", icon: <FaGitAlt />, color: "text-red-500" },
];

const Skills = () => {
  return (
    <section className="py-24 overflow-hidden">
      <h2 className="text-center text-4xl md:text-5xl font-bold text-lime-400 mb-12">
        My Skills
      </h2>

      <div className="relative w-full">
        {/* Blur edges */}
        <div className="absolute left-0 top-0 h-full w-24 bg-gradient-to-r from-black to-transparent z-10" />
        <div className="absolute right-0 top-0 h-full w-24 bg-gradient-to-l from-black to-transparent z-10" />

        <motion.div
          className="flex gap-10 w-max"
          animate={{ x: ["0%", "-50%"] }}
          transition={{
            repeat: Infinity,
            repeatType: "loop",
            duration: 20,
            ease: "linear",
          }}
          whileHover={{ animationPlayState: "paused" }}
        >
          {[...skills, ...skills].map((skill, i) => (
            <motion.div
              key={i}
              whileHover={{
                scale: 1.25,
                boxShadow: "0px 0px 30px rgba(132,204,22,0.8)",
              }}
              className="min-w-[160px] h-[140px] bg-zinc-900/80 backdrop-blur-md 
              rounded-2xl border border-zinc-700 flex flex-col 
              items-center justify-center cursor-pointer"
            >
              <div className={`text-5xl mb-3 ${skill.color}`}>{skill.icon}</div>
              <p className="text-white font-semibold">{skill.name}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
